/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Event_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Event Duration" |
*
* @param {Style_Guide_Manager_Event_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_event_duration_label = /** @type {((inputs?: Style_Guide_Manager_Event_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Event_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Duree d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisdauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件持续时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント期間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम की अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração do evento")
	return /** @type {LocalizedString} */ ("Event Duration")
});